import { render, staticRenderFns } from "./MatchNone.vue?vue&type=template&id=733372d1&"
import script from "./MatchNone.vue?vue&type=script&lang=ts&"
export * from "./MatchNone.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports